import React from 'react';
import Helmet from 'react-helmet';
import { BreadCrumbs } from '../components/BreadCrumbs';
import { DriverDetails } from '../components/DriverDetails';
import { Text } from '../components/Text';
import data from '../cachedData/deviceDrivers.json';
import { domainNProto } from '../data';
import NotFoundRoute from './NotFoundRoute';

const DriverDetailsRoute = ({
  match: {
    params: { code }
  }
}) => {
  const entity = data.filter(entity => entity.code === code)[0];

  if (entity) {
    return (
      <>
        <Helmet title={entity.name}>
          <meta property='og:type' content='website' />
          <meta property='og:title' content={entity.name} />
          <meta property='og:url' content={`${domainNProto}/support/software/${entity.code}`} />
          <meta
            property='og:description'
            content={`${entity.name} – программное обеспечение и драйверы торгового оборудования на Posprinters.ru`}
          />
        </Helmet>
        <BreadCrumbs crumbs={[['/support'], ['/support/software'], [entity.path, entity.name]]} />
        <Text type='h1'>{entity.name}</Text>
        <DriverDetails {...entity} />
      </>
    );
  }

  return <NotFoundRoute />;
};

export default DriverDetailsRoute;
